import { render, staticRenderFns } from "./StockCustomQuery.vue?vue&type=template&id=00f4fc4c&scoped=true"
import script from "./StockCustomQuery.vue?vue&type=script&lang=js"
export * from "./StockCustomQuery.vue?vue&type=script&lang=js"
import style0 from "./StockCustomQuery.vue?vue&type=style&index=0&id=00f4fc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4fc4c",
  null
  
)

export default component.exports